module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3efbbb96b14423a03bfe0fc0a5d4e461.png";